import {computedFn} from '@api'
import {IQueuedPdfServerJob, ISubmitPdfJobResponse} from '@modules/pdf'
import {CatalogStore} from '@stores'
import {CatalogInstanceChildStore} from '@stores/catalog/CatalogInstanceChildStore'
import {authStore} from '@utils'
import {computed, observable} from 'mobx'
import GET_USER from './getUser.graphql'
import {esClient} from '@stores/elasticsearch'

export interface IUser {
  username: string
  name?: string
  id: string
  image?: string
  firstName?: string
  lastName?: string
  emailAddress?: string
  active?: boolean
  shortName?: string,
  includesRoles?: boolean
}

/**
 * Per workspace and global user settings
 */
export interface IUserSettings {
  workspaces: {
    [workspace: string]: {
      notifications?: {
        desktop?: boolean
        email?: boolean
        phone?: boolean,
        lastQueriedWithResults?: Date
        watchedIds?: Set<string>
      }
    }
  }

  sync?: { showSnackbar?: boolean }
  recentReports?: string[]
  defaultReport?: string
  showC8Images?: boolean
  serverPDF?: boolean
  autoSaveReports?: boolean

  focusMode?: {
    enabled?: boolean
    footers?: boolean
    tabs?: boolean
    toolbars?: boolean
  }

  dev?: {
    localNest?: boolean
    localSAM?: boolean
    virtualizedCatalog?: boolean
  }
}

export interface IUserRole {
  exId: string
  createdAt: string
  updatedAt: string
  name: string
  description?: string
}

export class UsersStore extends CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore) {
    super(catalog)
    if (!catalog.isGlobalStore) throw new Error(`This class can only be used as a singleton in the global application store`)
  }

  @computed get current() { return authStore.user}

  private _userById = observable.map<string, IUser>({}, {deep: false})

  getById = computedFn((userId: string): Partial<IUser> => {
    if (!userId) return {}

    const {_userById, _loadingById} = this

    if (_userById.has(userId)) {
      return _userById.get(userId)
    } else {
      if (!_loadingById.has(userId)) {
        setTimeout(() => this._loadUser_c8(userId), 0)
      }
      return {...this.stores.authStore.user, includesRoles: false}
    }
  })

  @computed get user() { return this._currentUserAndRoles }

  @computed get _currentUserAndRoles () {
    const {getById, current} = this
    return getById(current?.id)
  }

  private _loadingById = observable.set<string>()

  _loadUser_c8 = async (userId: string) => {
    const {_loadingById, _userById} = this

    try {
      if (_userById.has(userId) || _loadingById.has(userId)) return
      _loadingById.add(userId)

      const {data} = await esClient.axiosNest.get(`c8/user/${encodeURIComponent(userId)}`)
      //console.log(userId, data)
      _userById.set(userId, {...data, includesRoles: true})
      _loadingById.delete(userId)

      return data
    } catch (err) {
      _loadingById.delete(userId)
      console.error(err)
    } finally {

    }
  }
}




// WEBPACK FOOTER //
// ./src/stores/user/UserStore.ts